import LinkToDocusaurus from '../LinkToDocusaurus'
import { environments } from '../../docs-routes'

const LinkToEnvironmentsIntroStateDoc = () =>
  <LinkToDocusaurus path={environments}>
    Learn more about Environments
  </LinkToDocusaurus>

export default LinkToEnvironmentsIntroStateDoc
